import Reveal from "@/components/Reveal";
import { BookOpenText, Leaf } from "lucide-react";

export default function Gusti({ gusti, t }) {
  return (
    <section id="gusti" data-testid="gusti-section" className="py-20 sm:py-28 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div>
            <p className="font-accent text-xs uppercase tracking-[0.25em] text-[#C86D51] mb-4">
              {t.gusti.over}
            </p>
            <h2 className="font-display tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#241C1A] leading-[1.1]">
              {t.gusti.title}
            </h2>
          </div>
          <p className="text-base text-[#6E625E] max-w-sm leading-relaxed">
            {t.gusti.sub}
          </p>
        </Reveal>

        <div className="mt-12 sm:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-7">
          {gusti.map((g, i) => (
            <Reveal key={g.name} delay={(i % 4) * 0.08}>
              <figure
                data-testid={`gusto-card-${i}`}
                className="group relative overflow-hidden rounded-3xl border border-[#241C1A]/10 bg-white shadow-sm hover:shadow-xl hover:-translate-y-1 transition-[box-shadow,transform] duration-300"
              >
                <div className="overflow-hidden">
                  <img
                    src={g.image}
                    alt={`Gelato ${g.name} — Fiordipanna`}
                    loading="lazy"
                    className="w-full aspect-[4/5] object-cover group-hover:scale-[1.05] transition-transform duration-700"
                  />
                </div>
                <figcaption className="p-4 sm:p-5">
                  <p className="font-display text-lg sm:text-xl text-[#241C1A] tracking-tight">
                    {g.name}
                  </p>
                  <p className="mt-1 text-xs sm:text-sm leading-relaxed text-[#6E625E]">{g.desc}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-10 sm:mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5 rounded-3xl bg-[#F3ECE0] border border-[#241C1A]/10 px-6 sm:px-8 py-6">
            <p className="inline-flex items-center gap-2.5 text-sm text-[#506334] font-medium">
              <Leaf size={17} /> {t.gusti.gluten}
            </p>
            <a
              href="/libro-degli-ingredienti-delle-gelaterie-fiordipanna/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="ingredienti-link"
              className="inline-flex items-center gap-2 rounded-full border border-[#241C1A]/20 px-5 py-2.5 text-sm font-medium text-[#241C1A] hover:border-[#C86D51] hover:text-[#C86D51] transition-colors duration-300"
            >
              <BookOpenText size={16} /> {t.gusti.book}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
